import { createAuthClient } from "better-auth/client";

export const authClient = createAuthClient({
  baseURL: process.env.REACT_APP_BASE_URL || "http://localhost:8001",
  basePath: "/api/auth",
}); 
